import React, { useState, useEffect, useRef, useContext } from "react";
import { Dropdown } from "./Dropdown";
import { useNavigate } from "react-router-dom";
import { stateContext } from "./Context";
import { downloadAsWord, downloadTxtFile } from "./downloadFileAs";

export const MenuItem = (props) => {
  let {
    items,
    depthLevel,
  } = props;

  let {
    quill,
    Quill,
    docId,
    docTitle,
    enableSynonym,
    setEnableSynonym,
    showWordCount,
    setShowWordCount,
    showNER,
    setShowNER,
    showFindnReplace,
    setShowFindnReplace,
    storeDataToServer,
    showLinkDialogBox,
    setShowLinkDialogBox,
    enableSpellChecker,
    setEnableSpellChecker,
    showModal,
    setShowModal,
    setTargetButton,
    quillTextWithoutMedia,
    selectedTextFromMenu,
    setSelectedTextFromMenu,
    tempText,
    setTempText,
    rangeIndex,
    showParaphrase,
    setShowParaphrase,
    createParaphraseDropdown
  } = useContext(stateContext)

  
  const [dropdown, setDropdown] = useState(false);

  let ref = useRef();
  
  const history = useNavigate()

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    window.innerWidth > 720 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 720 && setDropdown(false);
  };




  const setActive = (menuItemName) => {
    const ele = document.getElementById(menuItemName)
    // console.log(ele)
    if (enableSynonym) {
      let checkMark = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="24" height="24"
      viewBox="0 0 24 24"
      style=" fill:#000000;"><path d="M 19.980469 5.9902344 A 1.0001 1.0001 0 0 0 19.292969 6.2929688 L 9 16.585938 L 5.7070312 13.292969 A 1.0001 1.0001 0 1 0 4.2929688 14.707031 L 8.2929688 18.707031 A 1.0001 1.0001 0 0 0 9.7070312 18.707031 L 20.707031 7.7070312 A 1.0001 1.0001 0 0 0 19.980469 5.9902344 z"></path></svg>`
      ele.insertAdjacentHTML('afterend', checkMark)
      ele.parentElement.classList.add('active-menu-item')
    } else if (enableSynonym === false) {
      if (ele.parentElement.childElementCount === 2) {
        ele.parentElement.removeChild(ele.parentElement.children[1])
        ele.parentElement.classList.remove('active-menu-item')
      }
    }
  }


  
  useEffect(() => {
    if (items.title === 'Synonyms') {
      setActive('Synonyms')
    }
  },[enableSynonym])
  

  const deleteDoc = async () => {
    
    if (window.confirm('Are you sure to delete this document...')) {  
      var requestOptions = {
        method: 'DELETE',
        redirect: 'follow'
      };
      
      let data = await fetch(`http://139.59.17.33:8018/ailaysa-creator/${docId}/`, requestOptions)
      if (data.status === 200) {
        // const response = await data.json();
        // window.alert("File Deleted Successfully.");
        // console.log(data)
        history('/')
      }
    }
  }

  const [txt, setTxt] = useState('')
  const [txtIndex, setTxtIndex] = useState(null)
  const [rangeLength, setRangeLength] = useState(null)
  const [txtFormat, setTxtFormat] = useState(null)

  if (quill) {
    quill.on('selection-change', function(range, oldRange, source) {
      if (range) {
        var text = quill.getText(range.index, range.length);
        setTxt(text)
        setTxtIndex(range.index)
        setRangeLength(range.length)
        setTxtFormat(quill.getFormat(range.index, range.length))
      }
    });
  }


  const toLowerCase = () => {
    let lowercaseWord = txt.toLowerCase()
    quill.deleteText(txtIndex, txt.length)
    quill.insertText(txtIndex, `${lowercaseWord}`, txtFormat)
  }

  const toUpperCase = () => {
    let uppercaseWord = txt.toUpperCase()
    quill.deleteText(txtIndex, txt.length)
    quill.insertText(txtIndex, `${uppercaseWord}`, txtFormat)
  }


  function toTitleCaseFunction(str) {
    return str.toLocaleLowerCase().replace(
      /(^|\w)\S*/g,
      (txt) => txt.charAt(0).toLocaleUpperCase() + txt.substring(1),
    )
  }
  const toTitleCase = () => {
    let titlecaseWord = toTitleCaseFunction(txt)
    quill.deleteText(txtIndex, txt.length)
    quill.insertText(txtIndex, `${titlecaseWord}`, txtFormat)
  }
 
  const fullScreenView = () => {
    let editorHeader = document.getElementsByClassName('editor-header')[0]
    let qlToolbar = document.getElementsByClassName('ql-toolbar')[0]
    editorHeader.style.display = 'none'
    qlToolbar.style.display = 'none'
    setTimeout(() => {
      alert('Controls hidden. Press ESC to show controls.')
    }, 60);
  }

  if (quill) {
    let body = document.getElementsByTagName('body')[0]
    body.addEventListener('keyup', (e) => {
      if(e.key === "Escape"){
        let editorHeader = document.getElementsByClassName('editor-header')[0]
        let qlToolbar = document.getElementsByClassName('ql-toolbar')[0]
        editorHeader.style.display = 'block'
        qlToolbar.style.display = 'block'
      }
    })
  }

  const deleteTextFromMenu = () => {
    quill.deleteText(0, selectedTextFromMenu.length)
    setSelectedTextFromMenu('')
  }

  const selectAll = () => {
    let txt = quillTextWithoutMedia()
    quill.setSelection(0, txt.length)
  }
  

  const cutFunctionality = () => {
    copyFunctionality()
    quill.deleteText(txtIndex,rangeLength)
  }
  
  
  const copyFunctionality = () => {
    // console.log('copy') 
    // console.log(rangeLength)
    // console.log(txtIndex)
    let ele = null
    if (rangeLength) {
      ele = quill.getContents(txtIndex, rangeLength)
      // console.log(ele)
      setTempText(ele)
    }
  }

  
  const pasteFunctionality = () => {
    var Delta = Quill.import('delta');    
    if (tempText) {
      quill.updateContents(new Delta().retain(rangeIndex).concat(tempText))
      // console.log(tempText)
      // setTempText(null)
    }
  } 

  const undoFunctionality = () => {
    quill.history.undo();
  }
  const redoFunctionality = () => {
    quill.history.redo();
  }

  // document.onkeyup = function (e) { 
  //   if (e.ctrlKey && e.keyCode == ('C').charCodeAt(0)) { 
  //     e.preventDefault();
  //     copyFunctionality()
  //   }
  //   if (e.ctrlKey && e.keyCode == ('V').charCodeAt(0)) { 
  //     pasteFunctionality()
  //   }
  // }

  return (
    <li
      className="menu-items"
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {items.submenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={() => setDropdown((prev) => !prev)}
          >
            {items.title} {depthLevel > 0 ? <span>&rsaquo;</span> : null}
          </button>
          <Dropdown
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            toLowerCase={toLowerCase}
            toUpperCase={toUpperCase}
            toTitleCase={toTitleCase}
            fullScreenView={fullScreenView}
          />
        </>
      ) : (
        <p id={items.title}
          onClick={() => {
            switch (items.title) {
              case "New":
                window.open("/editor-page", "_blank");
                break;
              case "Save":
                // saveDocument();
                storeDataToServer();
                break;
              case "Named Entity (NER)":
                setShowNER(!showNER)
                break;
              case "Synonyms":
                setEnableSynonym(!enableSynonym);
                break;
              case "Paraphrase":
                setShowParaphrase(!showParaphrase)
                createParaphraseDropdown()
                break;
              case "Microsoft Word (.docx)":
                downloadAsWord(quill, docTitle);
                break;
              case "Plain Text (.txt)":
                downloadTxtFile(quill, docTitle)
                break;
              case "Move to Trash":
                deleteDoc();
                break;
              case "Undo":
                undoFunctionality()
                break;
              case "Redo":
                redoFunctionality()
                break;
              case "Cut":
                cutFunctionality()
                break;
              case "Copy":
                copyFunctionality()
                break;
              case "Paste":
                pasteFunctionality()
                break;
              case "Delete":
                deleteTextFromMenu();
                break;
              case "Select All":
                selectAll();
                break;
              case "Full Screen":
                fullScreenView()
                break;
              case "Link":
                setShowLinkDialogBox(!showLinkDialogBox)
                break;
              case "Find and Place":
                setShowFindnReplace(!showFindnReplace)
                break;
              case "Spell Checker":
                setEnableSpellChecker(!enableSpellChecker)
                break;
              case "lowercase":
                toLowerCase();
                break;
              case "UPPERCASE":
                toUpperCase();
                break;
              case "Title Case":
                toTitleCase();
                break;
              case "Word Count":
                setShowWordCount(!showWordCount)
                break;
              case "Keyboard Shortcuts":
                setTargetButton(items.title)
                setShowModal(!showModal)
                break;
              default:
                console.log("Selected wrong menu item.");
                break;
            }
          }}
        >
          {items.title}
        </p>
      )}
    </li>
  );
};
